import { useEffect, useState } from "react";

import type { GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useGetPhysicianUnhandledPatients } from "api/hooks/useGetPhysicianUnhandledPatients";
import { paginationModel, usePagination } from "api/hooks/usePagination";
import { MUIDataGrid } from "shared/molecules/MUIDataGrid";

interface Props {
  columns: GridColDef[];
}

export const UnhandledPatients: React.FC<Props> = ({ columns }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pagination, setPagination } = usePagination();
  const { data, isLoading } = useGetPhysicianUnhandledPatients({ limit: pagination.limit, page: pagination.page + 1 });
  const rows = data?.items || [];
  const metadata = data?.metadata;
  const [rowCountState, setRowCountState] = useState(metadata?.total_count);

  useEffect(() => {
    setRowCountState(prevRowCountState =>
      metadata?.total_count !== undefined ? metadata.total_count : prevRowCountState
    );
  }, [metadata, setRowCountState]);

  return (
    <MUIDataGrid
      columns={columns}
      rows={rows}
      getRowId={row => row.patient_id}
      loading={isLoading}
      initialState={{ pagination: { paginationModel } }}
      paginationMode="server"
      onPaginationModelChange={model => setPagination({ limit: model.pageSize, page: model.page })}
      rowCount={rowCountState}
      onCellClick={({ field, row }) => {
        if (field !== "medical_referral_status" && field !== "plan_of_care_status") {
          navigate(`/patients/${row.patient_id}`);
        }
      }}
      localeText={{ noRowsLabel: t("physician.unhandled_patients_no_rows") }}
      title={t("dashboard.tables.physician.unhandled_patients")}
    />
  );
};
